// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","error":"App_error__1umzI"};